var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_6646",
    "data-name": "Grupo 6646",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.781,
    height: 48.862,
    viewBox: "0 0 48.781 48.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2589",
    "data-name": "Rect\\xE1ngulo 2589",
    width: 48.781,
    height: 48.862,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6645",
    "data-name": "Grupo 6645",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5428",
    "data-name": "Trazado 5428",
    d: "M45.072,13.039l-3.228,2.472a20.206,20.206,0,1,1-7.9-7.856l2.474-3.23a24.229,24.229,0,1,0,8.655,8.614",
    transform: "translate(0 -0.693)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5429",
    "data-name": "Trazado 5429",
    d: "M52.219,33.916l-3,2.875a10.058,10.058,0,1,1-4.364-4.364l2.875-3a14.123,14.123,0,1,0,4.484,4.484",
    transform: "translate(-16.048 -16.741)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5430",
    "data-name": "Trazado 5430",
    d: "M56.246,61.4a4.027,4.027,0,1,1,4.027-4.027A4.031,4.031,0,0,1,56.246,61.4",
    transform: "translate(-32.033 -32.727)",
    fill: "#fc5145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5431",
    "data-name": "Trazado 5431",
    d: "M104.7,6.442l-5.127-.969L98.605.346A.425.425,0,0,0,97.85.167l-6.128,8,.171,4.985,4.985.171,8-6.128a.425.425,0,0,0-.179-.755",
    transform: "translate(-56.266 0)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5432",
    "data-name": "Trazado 5432",
    d: "M75.709,23.5,58.62,39.905l-1.294-1.294,16.4-17.088Z",
    transform: "translate(-35.167 -13.203)",
    fill: "#052941"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSvg);
export default __webpack_public_path__ + "static/media/Target-svg.2ed73dbe3ccbb968a15266900736ea60.svg";
export { ForwardRef as ReactComponent };